__webpack_require__.p = "https://static-dev.mylighthouse.com/lumen/";